export const isPartnerRunningStandalone = () => {
  return process.env.VUE_APP_PARTNER_STANDALONE === 'true';
};

export const redirectToPartnerArea = (path: string) => {
  const urlPrefix = `${location.protocol}//${location.host}`;
  window.location.href = `${urlPrefix}/partner/#/${path}`;
};
